import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  Modal,
  TextInput,
  Button,
  Alert,
} from 'react-native';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot, doc, updateDoc } from 'firebase/firestore';

const RoutesScreen = () => {
  const [routes, setRoutes] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentRouteId, setCurrentRouteId] = useState(null);
  const [routeValue, setRouteValue] = useState('');

  // Carrega rotas pendentes
  useEffect(() => {
    const unsubscribe = loadPendingRoutes();
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const loadPendingRoutes = () => {
    const routesQuery = query(collection(db, 'routes'), where('status', '==', 'pending'));
    const unsubscribe = onSnapshot(routesQuery, (snapshot) => {
      const routesArray = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
        companyName: doc.data().companyName || 'Empresa não disponível',
      }));
      setRoutes(routesArray);
    });
    return unsubscribe;
  };

  // Abre o modal para capturar o valor da rota
  const handleSaveRoute = (routeId) => {
    console.log('Salvando rota ID:', routeId); // Diagnóstico
    setCurrentRouteId(routeId);
    setIsModalVisible(true);
  };

  // Salva o valor da rota no Firebase
  const saveRouteValue = async () => {
    if (!routeValue || isNaN(routeValue)) {
      Alert.alert('Erro', 'Por favor, insira um valor válido.');
      return;
    }
    try {
      const routeRef = doc(db, 'routes', currentRouteId);
      await updateDoc(routeRef, {
        routeValue: parseFloat(routeValue),
        status: 'saved',
      });
      Alert.alert('Sucesso', `Rota salva com valor: R$ ${routeValue}`);
    } catch (error) {
      console.error('Erro ao salvar rota:', error);
      Alert.alert('Erro', 'Falha ao salvar a rota.');
    } finally {
      setIsModalVisible(false);
      setRouteValue('');
      setCurrentRouteId(null);
    }
  };

  const renderRoutes = ({ item }) => (
    <View style={styles.route}>
      <Text style={styles.routeText}>Empresa: {item.companyName}</Text>
      <TouchableOpacity style={styles.saveButton} onPress={() => handleSaveRoute(item.id)}>
        <Text style={styles.saveButtonText}>Salvar Rota</Text>
      </TouchableOpacity>
    </View>
  );

  return (
    <View style={styles.container}>
      <FlatList
        data={routes}
        keyExtractor={(item) => item.id}
        renderItem={renderRoutes}
        ListEmptyComponent={<Text style={styles.emptyText}>Nenhuma rota disponível no momento.</Text>}
      />

      {/* Modal para Capturar o Valor */}
      <Modal visible={isModalVisible} transparent animationType="slide">
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalTitle}>Qual o valor da rota?</Text>
            <TextInput
              style={styles.input}
              keyboardType="numeric"
              placeholder="Digite o valor em R$"
              value={routeValue}
              onChangeText={setRouteValue}
            />
            <View style={styles.modalButtons}>
              <Button title="Cancelar" onPress={() => setIsModalVisible(false)} />
              <Button title="Salvar" onPress={saveRouteValue} />
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: '#FFF',
  },
  route: {
    backgroundColor: '#FFF',
    padding: 16,
    marginBottom: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#000',
  },
  routeText: {
    fontSize: 16,
    color: '#000',
    marginBottom: 8,
  },
  saveButton: {
    backgroundColor: '#000',
    padding: 10,
    borderRadius: 5,
    alignItems: 'center',
    marginTop: 10,
  },
  saveButtonText: {
    color: '#FFF',
    fontSize: 16,
  },
  emptyText: {
    textAlign: 'center',
    fontSize: 16,
    color: '#999',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    backgroundColor: '#FFF',
    padding: 20,
    borderRadius: 10,
    width: '80%',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 18,
    marginBottom: 10,
  },
  input: {
    borderWidth: 1,
    borderColor: '#CCC',
    borderRadius: 5,
    width: '100%',
    padding: 10,
    marginBottom: 20,
  },
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
});

export default RoutesScreen;
